import React from "react";
import EntityForm from "../../EntityForm/EntityForm";
import { entityToFormValuesMapper } from "../../../Common/utils";
import { defineMessages, injectIntl } from "react-intl";

const messages = defineMessages({
  mustSetDateRange: {
    id: "app.entityForm.mustSetDateRange",
    description: "Date range must be set",
    defaultMessage: "Date range must be set",
  },
});

function customEntityToFormValuesMapper({ entity, fields, locales, translationConfig }) {
  const formValues = entityToFormValuesMapper({
    entity,
    fields,
    locales,
    translationConfig,
  });

  return {
    ...formValues,
    startDate: formValues.startDate || null,
    endDate: formValues.endDate || null,
  };
}

class ModificationBookingWindowForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  getFields(fields) {
    return fields && fields.form;
  }

  handleSubmit = ({ formValues }) => {
    const { id, ...otherFormValues } = formValues;

    const entity = {
      ...otherFormValues,
      _tempId: formValues._tempId,
    };

    this.props.onSubmitEntity({
      entity,
    });
  };

  customValidate = formValues => {
    if (!formValues.startDate || !formValues.endDate) {
      return this.props.intl.formatMessage(messages.mustSetDateRange);
    }
    return "";
  };

  render() {
    const { config } = this.props;
    const { name, validation, fields, renderers, translation, entities } = config;
    const {
      locales,
      entity,
      entityError,
      entityResult,
      loading,
      getListPath,
      nested,
      afterSubmit,
      onCancelEdit,
      entityName,
    } = this.props;
    const { getFields, handleSubmit } = this;
    return (
      <EntityForm
        loading={loading}
        name={name}
        entityName={entityName}
        entity={entity}
        entities={entities}
        validation={validation}
        renderers={renderers}
        fields={getFields(fields)}
        locales={locales}
        translation={translation}
        onSubmit={handleSubmit}
        entityError={entityError}
        customValidate={this.customValidate}
        entityResult={entityResult}
        getListPath={getListPath}
        nested={nested}
        afterSubmit={afterSubmit}
        onCancelEdit={onCancelEdit}
        entityToFormValuesMapper={customEntityToFormValuesMapper}
      />
    );
  }
}

ModificationBookingWindowForm.propTypes = {};

ModificationBookingWindowForm.defaultProps = {};

export default injectIntl(ModificationBookingWindowForm);

